import React from 'react';
import { ReactComponent as Logo } from '../../../assets/common/Logo-Red.svg';
import { ReactComponent as Welcome } from './icons/welcome-text.svg';

import { Link } from 'react-router-dom';
import RealTimeClock from '../real-time/RealTime';
export const TeamStatsHeader: React.FC = () => {
  return (
    <header>
      <div className='container max-sm:px-4 flex flex-wrap justify-between mx-auto items-center pt-[30px] pb-[22px]'>
        <Link to='/'>
          <Logo />
        </Link>
        <div className='flex gap-1 items-center'>
          <span></span>
          <Welcome /> <span className='text-[18px]'>👋🏽</span>
        </div>
        <div className='text-[#6F7376] font-normal text-[16px]'>
          <RealTimeClock />
        </div>
      </div>
    </header>
  );
};
